'use strict';
/* jshint ignore:start */
var giftsubscription = {

	giftSubscriptionActivationEvent: function (e) {
		var obj = {
			'event': 'Gift Subscription Activation',
			'button_ID': e.target.id ? e.target.id : e.target.innerText,
			'subscription_type': $('#check-gift-subscription').find('[name="dwfrm_giftsubscription_selectedProductID"]').val(),
			'subscription_value': $('#check-gift-subscription').find('[name="dwfrm_giftsubscription_giftCardAmount"]').val(),
			'subscription_voucher': $('#dwfrm_giftsubscription_giftCertCode').val(),
			're_product_url': '',
			're_tasting_club_introductory_selection': '',
			're_tasting_club_product': 'yes'
		};
		$.extend(obj, getCustomerData());
		dataLayer.push(obj);
	},

	giftSubscriptionAddedToBasketEvent: function (e) {
		var obj = {
			'event': 'gift subscription added to basket',
			'button_ID': e.target.id ? e.target.id : e.target.innerText
		};
		var productDataInput = $('input[name=productData]');
		if (productDataInput.length > 0) {
			var productObj = JSON.parse(productDataInput.val());
			obj['product_brand'] = productObj.productBrand;
			obj['product_category'] = productObj.productCategory;
			obj['product_discount'] = productObj.productDiscount;
			obj['product_hierarchy'] = productObj.productHierarchy;
			obj['product_ID'] = productObj.productID;
			obj['product_name'] = productObj.productName;
			obj['product_price'] = productObj.price;
			var oldPrice = '';
			if ($('.product-price .price-standard').length > 0) {
				oldPrice = $('.product-price .price-standard').text().substring(1);
			}
			obj['product_price_old'] = oldPrice;
			obj['product_quantity'] = 1;
			obj['product_SKU'] = productObj.productSKU;
			obj['product_vat'] = productObj.tax;
		}
		obj['subscription_status'] = 'active';
		obj['subscription_type'] = 'Tasting Club';
		obj['subscription_value'] = productObj.price;
		obj['re_recipient_name'] = $('input[name="dwfrm_giftcert_purchase_recipient"]').val() || '';
		dataLayer.push(obj);
	}
};

function getCustomerData() {
	if ($('input[name=customerData]').length > 0) {
		var customer = JSON.parse($('input[name=customerData]').val());
		// object to be pushed
		var obj = {
			're_3rd_party_permit': customer.re_3rd_party_permit,
			're_address1': customer.re_address1,
			're_address2': customer.re_address2,
			're_company_name': customer.re_company_name,
			're_country': customer.re_country,
			're_email_address': customer.re_email_address,
			're_job_title': customer.re_job_title,
			're_last_name': customer.re_last_name,
			're_mobile_number': customer.re_mobile_number,
			're_title': customer.re_title
		};
		return obj;
	}
}

/**
 * Utility function to get availability message from PDP page
 *
 * @returns {String}
 */
function getAvailabilityMsg() {
	var availabilityMsg = '';
	if ($('.availability-msg').children(0).length > 1) {
		if ($('.slick-active').length > 0) {
			var messageDiv = $('.slick-active').find('.availability-msg');
			if (messageDiv.length > 0) {
				availabilityMsg = messageDiv.find('.availability-msg').text().trim();
			}
		}
	} else {
		availabilityMsg = $('.availability-msg').children(0).text();
	}
	return availabilityMsg;
}

/**
 * Utility function to get product variant value
 *
 * @returns {String}
 */
function getProductVariant() {
	var variant = '';
	if ($('.variation-select').find('option:selected').length > 0) {
		variant = $('.variation-select').find('option:selected').text().trim();
	}
	return variant;
}

/**
 * Utility function to get old price from PDP page
 *
 * @returns {String}
 */
function getOldPrice() {
	var oldPrice = '';
	if ($('.product-price .price-standard').length > 0) {
		oldPrice = $('.product-price .price-standard').text().substring(1);
	}
	return oldPrice;
}

module.exports = giftsubscription
/* jshint ignore:end */
